import { Instagram, Youtube, ArrowUpRight } from "lucide-react";

const SOCIALS = [
  { icon: Instagram, label: "Instagram" },
  { icon: Youtube, label: "YouTube" },
];

const LINKS = ["Terms of Service", "Privacy Policy", "Certifications"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#090A0E]">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-10 lg:flex-row lg:items-end">
          <div>
            <img src="/media/logo.png" alt="Elite Mobile Detail" data-testid="footer-brand-logo" className="h-16 w-auto" />
            <p className="mt-3 max-w-sm font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-slate-600">
              Mobile Detailing — We Come To You · +61 417 406 332 · info@elitemobiledetail.com.au
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href="#top"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                aria-label={s.label}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-400 transition-[border-color,color] duration-300 hover:border-[#FFB703]/60 hover:text-[#FFB703]"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
            {LINKS.map((l) => (
              <a
                key={l}
                href="#top"
                data-testid={`footer-link-${l.toLowerCase().replace(/\s/g, "-")}`}
                className="group flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-white"
              >
                {l}
                <ArrowUpRight className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            ))}
          </div>
        </div>
        <div className="mt-12 flex flex-col justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-700">
            © {new Date().getFullYear()} Elite Mobile Detail
          </p>
          <a href="/login" data-testid="footer-owner-login" className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-700 transition-colors hover:text-[#FFB703]">
            Owner Login
          </a>
        </div>
      </div>
    </footer>
  );
}
